export default __webpack_public_path__ + "static/orangepiercingdust-3b1a0e17ce7d7358f930fd4388091333.png";